import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/ascend.svg';
const Ascend = () => React.createElement(IconSvg, null);
export default Ascend;
